module.exports = __webpack_public_path__ + "static/media/printer.b755a78f.png";